export default {
  feedback: {
    success: 'Mobile App erfolgreich gespeichert',
    error: 'Fehler beim Speichern der Mobile App',
  },
};
